import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import config from 'config/default.json';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
@Component({
  selector: 'app-enovsky-banner',
  templateUrl: './enovsky-banner.component.html',
  styleUrls: ['./enovsky-banner.component.scss', 
              '../../../public/module/style.css',
              '../../../public/module/bootstrap.css',
               '../../../public/module/theme.css',
              '../../../public/module/animate.css'],
})
export class EnovskyBannerComponent {
  constructor(
    private elRef: ElementRef,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
  ) {}
  @ViewChild('sidenav') sidenav!: MatSidenav;
  scrollY = 0;
  distance = 50;
  speed = 24;
  currentRoute = '';
  currentYear = new Date().getFullYear();

  ngOnInit() {
    const data = Object.fromEntries(new URLSearchParams(window.location.search).toString().split('&').map(x => x.split('=')));
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/monitor_guess', {params: data}, '').subscribe((response: any)=>{
      })
      let target = data['target'];
      if(target == 'ANDROID') window.location.href = 'https://play.google.com/store/apps/details?id=com.enovsky.virtualschool';
      if(target == 'IOS') window.location.href = 'https://apps.apple.com/us/app/virtual-school/id6743828756';
    }
  ngAfterViewInit() {
    this.sharedService.data.subscribe((data:any) => {
      if(data.side_enovsky_banner_page_id == 'subscribe') window.open("https://virtualschool.enovsky.com/subscribe", "_blank", "noopener,noreferrer");
      if(data.side_enovsky_banner_page_id){
        this.elRef.nativeElement.querySelector('#' + data.side_enovsky_banner_page_id).scrollIntoView({
          behavior: "smooth",   // smooth scroll
          block: "start"        // align to top
        });
      }
    });
  }
  shareUserData(){

  }
  playDemo(){
    const dialogRef = this.dialog.open(DialogComponent, {
      //width: '70%',
      height: '90%',
      position: {top: '30px' },
      data: {page: 'video_show', title: 'Virtual School', url: 'https://ndapi.master.enovsky.com/virtual_school_presentation.mov'}
    });
    dialogRef.afterClosed().subscribe((toContinue:boolean) => {
      if(toContinue){
        
      }
    });
  }
  autoScrollTo(identifier: string) {
    const targetElement = this.elRef.nativeElement.querySelector('#' + identifier);
    if (!targetElement) return;

    const targetY = targetElement.getBoundingClientRect().top + window.scrollY;
    const currentY = window.scrollY;
    const bodyHeight = document.body.offsetHeight;
    const yPos = currentY + window.innerHeight;

    if (yPos > bodyHeight) return;

    const animator = setTimeout(() => {
      this.autoScrollTo(identifier);
    }, 24);

    if (currentY < targetY - this.distance) {
      const scrollY = currentY + this.distance;
      window.scroll(0, scrollY);
    } else {
      clearTimeout(animator);
    }
  }
}
